<!--eslint-disable-->
<template>
  <div class="passport-header">
    <el-row>
      <el-col :span="12">
        <svg
          t="1552748537975"
          class="logo"
          style="" viewBox="0 0 900 300"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="1491" xmlns:xlink="http://www.w3.org/1999/xlink"><defs>
          </defs>
          <path class="st0"
            d="M250.2,250.4c-6.7,11.8-21.9,15.9-33.6,9c-11.8-6.7-15.9-21.9-9-33.6c6.7-11.8,21.9-15.9,33.6-9
            C253,223.4,256.9,238.4,250.2,250.4L250.2,250.4z M61.2,250.5c-6.7,11.8-21.9,15.9-33.6,9c-11.8-6.9-15.9-21.9-9-33.6
            c6.7-11.8,21.9-15.9,33.6-9C64,223.6,67.9,238.8,61.2,250.5L61.2,250.5z M159.9,79.4l-8.2,14.2c-6.7,11.8-21.9,15.9-33.6,9
            c-11.8-6.7-15.9-21.9-9-33.6l8.2-14.2c6.7-11.8,21.9-15.9,33.6-9C162.7,52.4,166.8,67.6,159.9,79.4L159.9,79.4z M208.7,155
            l-41.1,71.2c-6.7,11.8-21.9,15.9-33.6,9c-11.8-6.7-15.9-21.9-9-33.6l41.1-71.2c6.7-11.8,21.9-15.9,33.6-9
            C211.5,128.1,215.6,143.3,208.7,155L208.7,155z M116.9,149.6l-24.7,42.8c-6.7,11.8-21.9,15.9-33.6,9c-11.8-6.7-15.9-21.9-9-33.6
            L74.3,125c6.7-11.8,21.9-15.9,33.6-9C119.7,122.7,123.6,137.9,116.9,149.6L116.9,149.6z M116.9,149.6 M451,164
            c-6.1,17.7-11.7,32.5-17,44.6h29.7c8.7,0,18.4-0.2,29-0.7v14.5c-10.6-0.5-19.1-0.7-25.4-0.7H352c-8.2,0-16.2,0.2-23.9,0.7v-14.5
            c7.7,0.5,15.5,0.7,23.2,0.7h67.4c8.2-18.9,14.6-35.8,19.2-50.8c4.6-15,7.9-27.6,9.8-37.7c3.4,2.4,9.4,4.8,18.1,7.3
            C462,134.1,457.1,146.3,451,164z M458.7,97.6c3.9,0,11.1-0.2,21.8-0.7v13.8c-10.2-0.5-19.3-0.7-27.6-0.7h-87
            c-5.8,0-14.5,0.2-26.1,0.7V96.9c11.6,0.5,20.3,0.7,26.1,0.7H458.7z M399.2,196.2c-3.4,1.9-8.5,4.4-15.2,7.3
            c-5.3-15-10.4-27.9-15.2-38.8c-4.8-10.9-9.9-21.6-15.2-32.3c4.4-2.4,9.2-4.8,14.5-7.3C384,157.6,394.4,181.3,399.2,196.2z
             M418.8,86.7c-3.9,2.4-8.5,5.1-13.8,8c-3.4-8.2-8.5-16.9-15.2-26.1c4.4-2.4,8.7-5.1,13.1-8C412.5,75.1,417.8,83.8,418.8,86.7z
             M542.1,62.8h16.7c-0.5,5.8-0.7,17.7-0.7,35.5c10.6,0,19.3-0.5,26.1-1.5v15.2c-6.8-0.5-15.5-0.7-26.1-0.7v29.7
            c3.9-1.9,11.4-6,22.5-12.3c0,4.8,0.2,9.7,0.7,14.5c-4.8,1.5-12.6,5.1-23.2,10.9v58.7c0,4.4-2.2,8-6.5,10.9
            c-4.4,2.9-13.1,5.1-26.1,6.5c0-5.8-1.7-11.4-5.1-16.7c9.2,1,15.2,1.1,18.1,0.4c2.9-0.7,4.4-3,4.4-6.9v-46.4
            c-10.6,4.8-18.6,9.4-23.9,13.8c-1.9-4.8-5.1-9.2-9.4-13.1c6.3-1.9,17.4-6.8,33.4-14.5v-35.5c-11.6,0-21.8,0.2-30.5,0.7V96.9
            c8.2,1,18.4,1.5,30.5,1.5C542.8,83.8,542.5,72,542.1,62.8z M674.1,74.4c-0.5,10.6-0.7,22-0.7,34.1v85.6c0,11.6,0.2,22.7,0.7,33.4
            h-15.2v-19.6h-48.6c-9.7,0-19.1,0.2-28.3,0.7v-14.5c9.2,0.5,18.6,0.7,28.3,0.7h48.6v-50h-34.1c-9.7,0-19.3,0.2-29,0.7v-13.8
            c9.7,0.5,19.3,0.7,29,0.7h34.1v-45h-44.2c-9.7,0-18.9,0.2-27.6,0.7V73.7c8.7,0.5,17.9,0.7,27.6,0.7H674.1z M745.9,74.4
            c6.8,0,14-0.2,21.8-0.7V86c-8.2-0.5-14.3-0.7-18.1-0.7h-10.9c-1.9,11.6-5.1,24.4-9.4,38.4H764c-0.5,8.2-0.7,15.5-0.7,21.8v34.8
            c0,6.3,0.2,15.5,0.7,27.6h-13.1v-13.1h-21.8v21h-13.8c0.5-12.1,0.7-21.8,0.7-29v-34.1c-3.4,6.3-7.3,13.3-11.6,21
            c-2.9-3.9-6.3-7.3-10.2-10.2c8.7-11.6,15.7-25,21-40.3c5.3-15.2,8.5-27.9,9.4-38.1c-8.7,0-17.4,0.2-26.1,0.7V73.7
            c8.7,0.5,16.2,0.7,22.5,0.7H745.9z M750.9,183.2v-47.9h-21.8v47.9H750.9z M814,173.8c5.8,0,15-0.2,27.6-0.7v13.1
            c-13.1-0.5-23.9-0.7-32.6-0.7h-18.9c-5.3,0-11.9,0.3-19.6,0.7V173c5.3,0.5,11.8,0.7,19.6,0.7H814z M825.6,141.9l7.3-60.2h-33.4
            c-8.2,0-16.7,0.2-25.4,0.7V69.3c8.7,1,17.2,1.5,25.4,1.5h48.6c-2.4,13.1-5.6,36.8-9.4,71.1h23.2c-1,5.3-1.8,14.3-2.5,26.8
            c-0.7,12.6-2.1,24.2-4,34.8c-1.9,10.6-5.2,17.5-9.8,20.7c-4.6,3.1-13.7,5.2-27.2,6.2c-0.5-5.3-2.4-10.6-5.8-16
            c12.6,0.5,20.5,0,23.9-1.5c3.4-1.5,5.8-8.6,7.3-21.4c1.5-12.8,2.4-25.5,2.9-38.1h-67.4c1.5-10.6,2.8-21.1,4-31.5
            c1.2-10.4,2.1-20.4,2.5-30.1l16,2.9c-1.9,4.8-3.5,11.5-4.7,19.9c-1.2,8.5-2.3,17.5-3.3,27.2H825.6z"></path>
        </svg>
      </el-col>
      <el-col :span="12" class="text-right">
        <a :href="websiteHome" class="btn-return">返回到主页</a>
        <el-button class="btn-register" @click="onRegister">免费试用</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  computed: {
    websiteHome() {
      return process.env.VUE_APP_SITE_HOST
    }
  },
  methods: {
    onRegister() {
      window.location.href = this.websiteHome + '/#register'
    }
  }
}
</script>

<style lang="scss">
.passport-header {
  height:70px;
  line-height:66px;
  background:#fff;
  padding:0 30px;
  position:relative;
  svg.logo {
    display: inline-block;
    vertical-align:middle;
    width:120px;
    .st0 {fill:#ff0000;}
    .st2 {fill:#FFFFFF;}
  }
  .text-right {
    text-align:right;
  }
  .btn-register {
    background:#F00;
    color:#fff;
    height:42px;
  }
  .btn-return {
    display: inline-block;
    margin-right:30px;
    font-size:16px;
  }
}
</style>
